module.exports = __webpack_public_path__ + "static/itc-avantgardestd-demi-5d47aaf8153d48dd50736317eb78ba23.woff2";